// extracted by mini-css-extract-plugin
export default {"page":"P1-z","cartModal":"Q1-z","checkout":"R1-z","placeholder":"S1-z","account":"T1-z"};